'use client';

/**
 * This file was automatically generated by the Stencil React Output Target.
 * Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 */

/* eslint-disable */

import React from 'react';
import { createComponent } from '@stencil/react-output-target/runtime';
import type { Components } from '@isovalent/mktg-isovalent-components/dist/components';
import { IsovAccordion as IsovAccordionElement, defineCustomElement as defineIsovAccordion } from '@isovalent/mktg-isovalent-components/dist/components/isov-accordion.js';
import { IsovAgendaItem as IsovAgendaItemElement, defineCustomElement as defineIsovAgendaItem } from '@isovalent/mktg-isovalent-components/dist/components/isov-agenda-item.js';
import { IsovAnimation as IsovAnimationElement, defineCustomElement as defineIsovAnimation } from '@isovalent/mktg-isovalent-components/dist/components/isov-animation.js';
import { IsovAnnouncementBar as IsovAnnouncementBarElement, defineCustomElement as defineIsovAnnouncementBar } from '@isovalent/mktg-isovalent-components/dist/components/isov-announcement-bar.js';
import { IsovAuthor as IsovAuthorElement, defineCustomElement as defineIsovAuthor } from '@isovalent/mktg-isovalent-components/dist/components/isov-author.js';
import { IsovAvatar as IsovAvatarElement, defineCustomElement as defineIsovAvatar } from '@isovalent/mktg-isovalent-components/dist/components/isov-avatar.js';
import { IsovBodyCta as IsovBodyCtaElement, defineCustomElement as defineIsovBodyCta } from '@isovalent/mktg-isovalent-components/dist/components/isov-body-cta.js';
import { IsovBodySubscribe as IsovBodySubscribeElement, defineCustomElement as defineIsovBodySubscribe } from '@isovalent/mktg-isovalent-components/dist/components/isov-body-subscribe.js';
import { IsovButton as IsovButtonElement, defineCustomElement as defineIsovButton } from '@isovalent/mktg-isovalent-components/dist/components/isov-button.js';
import { IsovCapture as IsovCaptureElement, defineCustomElement as defineIsovCapture } from '@isovalent/mktg-isovalent-components/dist/components/isov-capture.js';
import { IsovCard as IsovCardElement, defineCustomElement as defineIsovCard } from '@isovalent/mktg-isovalent-components/dist/components/isov-card.js';
import { IsovCarousel as IsovCarouselElement, defineCustomElement as defineIsovCarousel } from '@isovalent/mktg-isovalent-components/dist/components/isov-carousel.js';
import { IsovCategory as IsovCategoryElement, defineCustomElement as defineIsovCategory } from '@isovalent/mktg-isovalent-components/dist/components/isov-category.js';
import { IsovCheckmark as IsovCheckmarkElement, defineCustomElement as defineIsovCheckmark } from '@isovalent/mktg-isovalent-components/dist/components/isov-checkmark.js';
import { IsovContent as IsovContentElement, defineCustomElement as defineIsovContent } from '@isovalent/mktg-isovalent-components/dist/components/isov-content.js';
import { IsovContentItem as IsovContentItemElement, defineCustomElement as defineIsovContentItem } from '@isovalent/mktg-isovalent-components/dist/components/isov-content-item.js';
import { IsovContentSwitcher as IsovContentSwitcherElement, defineCustomElement as defineIsovContentSwitcher } from '@isovalent/mktg-isovalent-components/dist/components/isov-content-switcher.js';
import { IsovDropdown as IsovDropdownElement, defineCustomElement as defineIsovDropdown } from '@isovalent/mktg-isovalent-components/dist/components/isov-dropdown.js';
import { IsovFooter as IsovFooterElement, defineCustomElement as defineIsovFooter } from '@isovalent/mktg-isovalent-components/dist/components/isov-footer.js';
import { IsovForm as IsovFormElement, defineCustomElement as defineIsovForm } from '@isovalent/mktg-isovalent-components/dist/components/isov-form.js';
import { IsovHero as IsovHeroElement, defineCustomElement as defineIsovHero } from '@isovalent/mktg-isovalent-components/dist/components/isov-hero.js';
import { IsovIcon as IsovIconElement, defineCustomElement as defineIsovIcon } from '@isovalent/mktg-isovalent-components/dist/components/isov-icon.js';
import { IsovInput as IsovInputElement, defineCustomElement as defineIsovInput } from '@isovalent/mktg-isovalent-components/dist/components/isov-input.js';
import { IsovLogo as IsovLogoElement, defineCustomElement as defineIsovLogo } from '@isovalent/mktg-isovalent-components/dist/components/isov-logo.js';
import { IsovLogoBar as IsovLogoBarElement, defineCustomElement as defineIsovLogoBar } from '@isovalent/mktg-isovalent-components/dist/components/isov-logo-bar.js';
import { IsovMediaPlaceholder as IsovMediaPlaceholderElement, defineCustomElement as defineIsovMediaPlaceholder } from '@isovalent/mktg-isovalent-components/dist/components/isov-media-placeholder.js';
import { IsovNavGroup as IsovNavGroupElement, defineCustomElement as defineIsovNavGroup } from '@isovalent/mktg-isovalent-components/dist/components/isov-nav-group.js';
import { IsovNavItem as IsovNavItemElement, defineCustomElement as defineIsovNavItem } from '@isovalent/mktg-isovalent-components/dist/components/isov-nav-item.js';
import { IsovPagination as IsovPaginationElement, defineCustomElement as defineIsovPagination } from '@isovalent/mktg-isovalent-components/dist/components/isov-pagination.js';
import { IsovPrimaryNavigation as IsovPrimaryNavigationElement, defineCustomElement as defineIsovPrimaryNavigation } from '@isovalent/mktg-isovalent-components/dist/components/isov-primary-navigation.js';
import { IsovProduct as IsovProductElement, defineCustomElement as defineIsovProduct } from '@isovalent/mktg-isovalent-components/dist/components/isov-product.js';
import { IsovQuote as IsovQuoteElement, defineCustomElement as defineIsovQuote } from '@isovalent/mktg-isovalent-components/dist/components/isov-quote.js';
import { IsovRiverItem as IsovRiverItemElement, defineCustomElement as defineIsovRiverItem } from '@isovalent/mktg-isovalent-components/dist/components/isov-river-item.js';
import { IsovRiverLayout as IsovRiverLayoutElement, defineCustomElement as defineIsovRiverLayout } from '@isovalent/mktg-isovalent-components/dist/components/isov-river-layout.js';
import { IsovSplitText as IsovSplitTextElement, defineCustomElement as defineIsovSplitText } from '@isovalent/mktg-isovalent-components/dist/components/isov-split-text.js';
import { IsovTab as IsovTabElement, defineCustomElement as defineIsovTab } from '@isovalent/mktg-isovalent-components/dist/components/isov-tab.js';
import { IsovTabSwitcher as IsovTabSwitcherElement, defineCustomElement as defineIsovTabSwitcher } from '@isovalent/mktg-isovalent-components/dist/components/isov-tab-switcher.js';
import { IsovTag as IsovTagElement, defineCustomElement as defineIsovTag } from '@isovalent/mktg-isovalent-components/dist/components/isov-tag.js';
import { IsovTextStack as IsovTextStackElement, defineCustomElement as defineIsovTextStack } from '@isovalent/mktg-isovalent-components/dist/components/isov-text-stack.js';
import { IsovTrigger as IsovTriggerElement, defineCustomElement as defineIsovTrigger } from '@isovalent/mktg-isovalent-components/dist/components/isov-trigger.js';
import type { Event, IsovButtonCustomEvent, IsovCheckmarkCustomEvent, IsovContentItemCustomEvent, IsovInputCustomEvent, IsovNavItemCustomEvent, IsovTabCustomEvent, IsovTriggerCustomEvent } from '@isovalent/mktg-isovalent-components';
import type { StencilReactComponent, EventName } from '@stencil/react-output-target/runtime';

export type IsovAccordionEvents = NonNullable<unknown>;

export const IsovAccordion: StencilReactComponent<IsovAccordionElement, IsovAccordionEvents, Components.IsovAccordion> = /*@__PURE__*/ createComponent<IsovAccordionElement, IsovAccordionEvents, Components.IsovAccordion>({
    tagName: 'isov-accordion',
    elementClass: IsovAccordionElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovAccordionEvents,
    defineCustomElement: defineIsovAccordion,
});

export type IsovAgendaItemEvents = NonNullable<unknown>;

export const IsovAgendaItem: StencilReactComponent<IsovAgendaItemElement, IsovAgendaItemEvents, Components.IsovAgendaItem> = /*@__PURE__*/ createComponent<IsovAgendaItemElement, IsovAgendaItemEvents, Components.IsovAgendaItem>({
    tagName: 'isov-agenda-item',
    elementClass: IsovAgendaItemElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovAgendaItemEvents,
    defineCustomElement: defineIsovAgendaItem,
});

export type IsovAnimationEvents = NonNullable<unknown>;

export const IsovAnimation: StencilReactComponent<IsovAnimationElement, IsovAnimationEvents, Components.IsovAnimation> = /*@__PURE__*/ createComponent<IsovAnimationElement, IsovAnimationEvents, Components.IsovAnimation>({
    tagName: 'isov-animation',
    elementClass: IsovAnimationElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovAnimationEvents,
    defineCustomElement: defineIsovAnimation,
});

export type IsovAnnouncementBarEvents = NonNullable<unknown>;

export const IsovAnnouncementBar: StencilReactComponent<IsovAnnouncementBarElement, IsovAnnouncementBarEvents, Components.IsovAnnouncementBar> = /*@__PURE__*/ createComponent<IsovAnnouncementBarElement, IsovAnnouncementBarEvents, Components.IsovAnnouncementBar>({
    tagName: 'isov-announcement-bar',
    elementClass: IsovAnnouncementBarElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovAnnouncementBarEvents,
    defineCustomElement: defineIsovAnnouncementBar,
});

export type IsovAuthorEvents = NonNullable<unknown>;

export const IsovAuthor: StencilReactComponent<IsovAuthorElement, IsovAuthorEvents, Components.IsovAuthor> = /*@__PURE__*/ createComponent<IsovAuthorElement, IsovAuthorEvents, Components.IsovAuthor>({
    tagName: 'isov-author',
    elementClass: IsovAuthorElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovAuthorEvents,
    defineCustomElement: defineIsovAuthor,
});

export type IsovAvatarEvents = NonNullable<unknown>;

export const IsovAvatar: StencilReactComponent<IsovAvatarElement, IsovAvatarEvents, Components.IsovAvatar> = /*@__PURE__*/ createComponent<IsovAvatarElement, IsovAvatarEvents, Components.IsovAvatar>({
    tagName: 'isov-avatar',
    elementClass: IsovAvatarElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovAvatarEvents,
    defineCustomElement: defineIsovAvatar,
});

export type IsovBodyCtaEvents = NonNullable<unknown>;

export const IsovBodyCta: StencilReactComponent<IsovBodyCtaElement, IsovBodyCtaEvents, Components.IsovBodyCta> = /*@__PURE__*/ createComponent<IsovBodyCtaElement, IsovBodyCtaEvents, Components.IsovBodyCta>({
    tagName: 'isov-body-cta',
    elementClass: IsovBodyCtaElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovBodyCtaEvents,
    defineCustomElement: defineIsovBodyCta,
});

export type IsovBodySubscribeEvents = NonNullable<unknown>;

export const IsovBodySubscribe: StencilReactComponent<IsovBodySubscribeElement, IsovBodySubscribeEvents, Components.IsovBodySubscribe> = /*@__PURE__*/ createComponent<IsovBodySubscribeElement, IsovBodySubscribeEvents, Components.IsovBodySubscribe>({
    tagName: 'isov-body-subscribe',
    elementClass: IsovBodySubscribeElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovBodySubscribeEvents,
    defineCustomElement: defineIsovBodySubscribe,
});

export type IsovButtonEvents = {
  onClickEvent: EventName<IsovButtonCustomEvent<Event>>
};

export const IsovButton: StencilReactComponent<IsovButtonElement, IsovButtonEvents, Components.IsovButton> = /*@__PURE__*/ createComponent<IsovButtonElement, IsovButtonEvents, Components.IsovButton>({
    tagName: 'isov-button',
    elementClass: IsovButtonElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
      onClickEvent: 'clickEvent'
    } as IsovButtonEvents,
    defineCustomElement: defineIsovButton,
});

export type IsovCaptureEvents = NonNullable<unknown>;

export const IsovCapture: StencilReactComponent<IsovCaptureElement, IsovCaptureEvents, Components.IsovCapture> = /*@__PURE__*/ createComponent<IsovCaptureElement, IsovCaptureEvents, Components.IsovCapture>({
    tagName: 'isov-capture',
    elementClass: IsovCaptureElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovCaptureEvents,
    defineCustomElement: defineIsovCapture,
});

export type IsovCardEvents = NonNullable<unknown>;

export const IsovCard: StencilReactComponent<IsovCardElement, IsovCardEvents, Components.IsovCard> = /*@__PURE__*/ createComponent<IsovCardElement, IsovCardEvents, Components.IsovCard>({
    tagName: 'isov-card',
    elementClass: IsovCardElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovCardEvents,
    defineCustomElement: defineIsovCard,
});

export type IsovCarouselEvents = NonNullable<unknown>;

export const IsovCarousel: StencilReactComponent<IsovCarouselElement, IsovCarouselEvents, Components.IsovCarousel> = /*@__PURE__*/ createComponent<IsovCarouselElement, IsovCarouselEvents, Components.IsovCarousel>({
    tagName: 'isov-carousel',
    elementClass: IsovCarouselElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovCarouselEvents,
    defineCustomElement: defineIsovCarousel,
});

export type IsovCategoryEvents = NonNullable<unknown>;

export const IsovCategory: StencilReactComponent<IsovCategoryElement, IsovCategoryEvents, Components.IsovCategory> = /*@__PURE__*/ createComponent<IsovCategoryElement, IsovCategoryEvents, Components.IsovCategory>({
    tagName: 'isov-category',
    elementClass: IsovCategoryElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovCategoryEvents,
    defineCustomElement: defineIsovCategory,
});

export type IsovCheckmarkEvents = {
  onInputEvent: EventName<IsovCheckmarkCustomEvent<Event>>
};

export const IsovCheckmark: StencilReactComponent<IsovCheckmarkElement, IsovCheckmarkEvents, Components.IsovCheckmark> = /*@__PURE__*/ createComponent<IsovCheckmarkElement, IsovCheckmarkEvents, Components.IsovCheckmark>({
    tagName: 'isov-checkmark',
    elementClass: IsovCheckmarkElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
      onInputEvent: 'inputEvent'
    } as IsovCheckmarkEvents,
    defineCustomElement: defineIsovCheckmark,
});

export type IsovContentEvents = NonNullable<unknown>;

export const IsovContent: StencilReactComponent<IsovContentElement, IsovContentEvents, Components.IsovContent> = /*@__PURE__*/ createComponent<IsovContentElement, IsovContentEvents, Components.IsovContent>({
    tagName: 'isov-content',
    elementClass: IsovContentElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovContentEvents,
    defineCustomElement: defineIsovContent,
});

export type IsovContentItemEvents = {
  onClickEvent: EventName<IsovContentItemCustomEvent<Event>>
};

export const IsovContentItem: StencilReactComponent<IsovContentItemElement, IsovContentItemEvents, Components.IsovContentItem> = /*@__PURE__*/ createComponent<IsovContentItemElement, IsovContentItemEvents, Components.IsovContentItem>({
    tagName: 'isov-content-item',
    elementClass: IsovContentItemElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
      onClickEvent: 'clickEvent'
    } as IsovContentItemEvents,
    defineCustomElement: defineIsovContentItem,
});

export type IsovContentSwitcherEvents = NonNullable<unknown>;

export const IsovContentSwitcher: StencilReactComponent<IsovContentSwitcherElement, IsovContentSwitcherEvents, Components.IsovContentSwitcher> = /*@__PURE__*/ createComponent<IsovContentSwitcherElement, IsovContentSwitcherEvents, Components.IsovContentSwitcher>({
    tagName: 'isov-content-switcher',
    elementClass: IsovContentSwitcherElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovContentSwitcherEvents,
    defineCustomElement: defineIsovContentSwitcher,
});

export type IsovDropdownEvents = NonNullable<unknown>;

export const IsovDropdown: StencilReactComponent<IsovDropdownElement, IsovDropdownEvents, Components.IsovDropdown> = /*@__PURE__*/ createComponent<IsovDropdownElement, IsovDropdownEvents, Components.IsovDropdown>({
    tagName: 'isov-dropdown',
    elementClass: IsovDropdownElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovDropdownEvents,
    defineCustomElement: defineIsovDropdown,
});

export type IsovFooterEvents = NonNullable<unknown>;

export const IsovFooter: StencilReactComponent<IsovFooterElement, IsovFooterEvents, Components.IsovFooter> = /*@__PURE__*/ createComponent<IsovFooterElement, IsovFooterEvents, Components.IsovFooter>({
    tagName: 'isov-footer',
    elementClass: IsovFooterElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovFooterEvents,
    defineCustomElement: defineIsovFooter,
});

export type IsovFormEvents = NonNullable<unknown>;

export const IsovForm: StencilReactComponent<IsovFormElement, IsovFormEvents, Components.IsovForm> = /*@__PURE__*/ createComponent<IsovFormElement, IsovFormEvents, Components.IsovForm>({
    tagName: 'isov-form',
    elementClass: IsovFormElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovFormEvents,
    defineCustomElement: defineIsovForm,
});

export type IsovHeroEvents = NonNullable<unknown>;

export const IsovHero: StencilReactComponent<IsovHeroElement, IsovHeroEvents, Components.IsovHero> = /*@__PURE__*/ createComponent<IsovHeroElement, IsovHeroEvents, Components.IsovHero>({
    tagName: 'isov-hero',
    elementClass: IsovHeroElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovHeroEvents,
    defineCustomElement: defineIsovHero,
});

export type IsovIconEvents = NonNullable<unknown>;

export const IsovIcon: StencilReactComponent<IsovIconElement, IsovIconEvents, Components.IsovIcon> = /*@__PURE__*/ createComponent<IsovIconElement, IsovIconEvents, Components.IsovIcon>({
    tagName: 'isov-icon',
    elementClass: IsovIconElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovIconEvents,
    defineCustomElement: defineIsovIcon,
});

export type IsovInputEvents = {
  onInputEvent: EventName<IsovInputCustomEvent<Event>>
};

export const IsovInput: StencilReactComponent<IsovInputElement, IsovInputEvents, Components.IsovInput> = /*@__PURE__*/ createComponent<IsovInputElement, IsovInputEvents, Components.IsovInput>({
    tagName: 'isov-input',
    elementClass: IsovInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
      onInputEvent: 'inputEvent'
    } as IsovInputEvents,
    defineCustomElement: defineIsovInput,
});

export type IsovLogoEvents = NonNullable<unknown>;

export const IsovLogo: StencilReactComponent<IsovLogoElement, IsovLogoEvents, Components.IsovLogo> = /*@__PURE__*/ createComponent<IsovLogoElement, IsovLogoEvents, Components.IsovLogo>({
    tagName: 'isov-logo',
    elementClass: IsovLogoElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovLogoEvents,
    defineCustomElement: defineIsovLogo,
});

export type IsovLogoBarEvents = NonNullable<unknown>;

export const IsovLogoBar: StencilReactComponent<IsovLogoBarElement, IsovLogoBarEvents, Components.IsovLogoBar> = /*@__PURE__*/ createComponent<IsovLogoBarElement, IsovLogoBarEvents, Components.IsovLogoBar>({
    tagName: 'isov-logo-bar',
    elementClass: IsovLogoBarElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovLogoBarEvents,
    defineCustomElement: defineIsovLogoBar,
});

export type IsovMediaPlaceholderEvents = NonNullable<unknown>;

export const IsovMediaPlaceholder: StencilReactComponent<IsovMediaPlaceholderElement, IsovMediaPlaceholderEvents, Components.IsovMediaPlaceholder> = /*@__PURE__*/ createComponent<IsovMediaPlaceholderElement, IsovMediaPlaceholderEvents, Components.IsovMediaPlaceholder>({
    tagName: 'isov-media-placeholder',
    elementClass: IsovMediaPlaceholderElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovMediaPlaceholderEvents,
    defineCustomElement: defineIsovMediaPlaceholder,
});

export type IsovNavGroupEvents = NonNullable<unknown>;

export const IsovNavGroup: StencilReactComponent<IsovNavGroupElement, IsovNavGroupEvents, Components.IsovNavGroup> = /*@__PURE__*/ createComponent<IsovNavGroupElement, IsovNavGroupEvents, Components.IsovNavGroup>({
    tagName: 'isov-nav-group',
    elementClass: IsovNavGroupElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovNavGroupEvents,
    defineCustomElement: defineIsovNavGroup,
});

export type IsovNavItemEvents = {
  onClickEvent: EventName<IsovNavItemCustomEvent<Event>>
};

export const IsovNavItem: StencilReactComponent<IsovNavItemElement, IsovNavItemEvents, Components.IsovNavItem> = /*@__PURE__*/ createComponent<IsovNavItemElement, IsovNavItemEvents, Components.IsovNavItem>({
    tagName: 'isov-nav-item',
    elementClass: IsovNavItemElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
      onClickEvent: 'clickEvent'
    } as IsovNavItemEvents,
    defineCustomElement: defineIsovNavItem,
});

export type IsovPaginationEvents = NonNullable<unknown>;

export const IsovPagination: StencilReactComponent<IsovPaginationElement, IsovPaginationEvents, Components.IsovPagination> = /*@__PURE__*/ createComponent<IsovPaginationElement, IsovPaginationEvents, Components.IsovPagination>({
    tagName: 'isov-pagination',
    elementClass: IsovPaginationElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovPaginationEvents,
    defineCustomElement: defineIsovPagination,
});

export type IsovPrimaryNavigationEvents = NonNullable<unknown>;

export const IsovPrimaryNavigation: StencilReactComponent<IsovPrimaryNavigationElement, IsovPrimaryNavigationEvents, Components.IsovPrimaryNavigation> = /*@__PURE__*/ createComponent<IsovPrimaryNavigationElement, IsovPrimaryNavigationEvents, Components.IsovPrimaryNavigation>({
    tagName: 'isov-primary-navigation',
    elementClass: IsovPrimaryNavigationElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovPrimaryNavigationEvents,
    defineCustomElement: defineIsovPrimaryNavigation,
});

export type IsovProductEvents = NonNullable<unknown>;

export const IsovProduct: StencilReactComponent<IsovProductElement, IsovProductEvents, Components.IsovProduct> = /*@__PURE__*/ createComponent<IsovProductElement, IsovProductEvents, Components.IsovProduct>({
    tagName: 'isov-product',
    elementClass: IsovProductElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovProductEvents,
    defineCustomElement: defineIsovProduct,
});

export type IsovQuoteEvents = NonNullable<unknown>;

export const IsovQuote: StencilReactComponent<IsovQuoteElement, IsovQuoteEvents, Components.IsovQuote> = /*@__PURE__*/ createComponent<IsovQuoteElement, IsovQuoteEvents, Components.IsovQuote>({
    tagName: 'isov-quote',
    elementClass: IsovQuoteElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovQuoteEvents,
    defineCustomElement: defineIsovQuote,
});

export type IsovRiverItemEvents = NonNullable<unknown>;

export const IsovRiverItem: StencilReactComponent<IsovRiverItemElement, IsovRiverItemEvents, Components.IsovRiverItem> = /*@__PURE__*/ createComponent<IsovRiverItemElement, IsovRiverItemEvents, Components.IsovRiverItem>({
    tagName: 'isov-river-item',
    elementClass: IsovRiverItemElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovRiverItemEvents,
    defineCustomElement: defineIsovRiverItem,
});

export type IsovRiverLayoutEvents = NonNullable<unknown>;

export const IsovRiverLayout: StencilReactComponent<IsovRiverLayoutElement, IsovRiverLayoutEvents, Components.IsovRiverLayout> = /*@__PURE__*/ createComponent<IsovRiverLayoutElement, IsovRiverLayoutEvents, Components.IsovRiverLayout>({
    tagName: 'isov-river-layout',
    elementClass: IsovRiverLayoutElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovRiverLayoutEvents,
    defineCustomElement: defineIsovRiverLayout,
});

export type IsovSplitTextEvents = NonNullable<unknown>;

export const IsovSplitText: StencilReactComponent<IsovSplitTextElement, IsovSplitTextEvents, Components.IsovSplitText> = /*@__PURE__*/ createComponent<IsovSplitTextElement, IsovSplitTextEvents, Components.IsovSplitText>({
    tagName: 'isov-split-text',
    elementClass: IsovSplitTextElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovSplitTextEvents,
    defineCustomElement: defineIsovSplitText,
});

export type IsovTabEvents = {
  onClickEvent: EventName<IsovTabCustomEvent<Event>>
};

export const IsovTab: StencilReactComponent<IsovTabElement, IsovTabEvents, Components.IsovTab> = /*@__PURE__*/ createComponent<IsovTabElement, IsovTabEvents, Components.IsovTab>({
    tagName: 'isov-tab',
    elementClass: IsovTabElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
      onClickEvent: 'clickEvent'
    } as IsovTabEvents,
    defineCustomElement: defineIsovTab,
});

export type IsovTabSwitcherEvents = NonNullable<unknown>;

export const IsovTabSwitcher: StencilReactComponent<IsovTabSwitcherElement, IsovTabSwitcherEvents, Components.IsovTabSwitcher> = /*@__PURE__*/ createComponent<IsovTabSwitcherElement, IsovTabSwitcherEvents, Components.IsovTabSwitcher>({
    tagName: 'isov-tab-switcher',
    elementClass: IsovTabSwitcherElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovTabSwitcherEvents,
    defineCustomElement: defineIsovTabSwitcher,
});

export type IsovTagEvents = NonNullable<unknown>;

export const IsovTag: StencilReactComponent<IsovTagElement, IsovTagEvents, Components.IsovTag> = /*@__PURE__*/ createComponent<IsovTagElement, IsovTagEvents, Components.IsovTag>({
    tagName: 'isov-tag',
    elementClass: IsovTagElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovTagEvents,
    defineCustomElement: defineIsovTag,
});

export type IsovTextStackEvents = NonNullable<unknown>;

export const IsovTextStack: StencilReactComponent<IsovTextStackElement, IsovTextStackEvents, Components.IsovTextStack> = /*@__PURE__*/ createComponent<IsovTextStackElement, IsovTextStackEvents, Components.IsovTextStack>({
    tagName: 'isov-text-stack',
    elementClass: IsovTextStackElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {} as IsovTextStackEvents,
    defineCustomElement: defineIsovTextStack,
});

export type IsovTriggerEvents = {
  onClickEvent: EventName<IsovTriggerCustomEvent<Event>>
};

export const IsovTrigger: StencilReactComponent<IsovTriggerElement, IsovTriggerEvents, Components.IsovTrigger> = /*@__PURE__*/ createComponent<IsovTriggerElement, IsovTriggerEvents, Components.IsovTrigger>({
    tagName: 'isov-trigger',
    elementClass: IsovTriggerElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
      onClickEvent: 'clickEvent'
    } as IsovTriggerEvents,
    defineCustomElement: defineIsovTrigger,
});
